import React, { useState, useEffect } from 'react';
import CommonPaymentFailedIcon from "../../assets/img/CommonWarning.svg";
import Settings from "../../services/settings.service";
import DownloadApps from "../shared/DownloadApps";
import StorefrontTitle from "../shared/storefront-title.component";
import Translation from "../../services/translation.service";
import SpinnerTimeLoader from "../shared/timeLoading";
import Storage from "../../services/storage.service";
import SimDeactivationStepper from './stepper';
// import FirebaseAnalytics from '../../services/analytics.service';

const subscriptions = [];
const SuspendedSimDeactivation = (props) => {

  const prefix = "scr_3.3.3";
  const appDownloadInfo = Translation.keys[prefix + "_app_download_info"];
  const [loader, setLoader] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState("");

  useEffect(() => {
    setLoader(true);
    // FirebaseAnalytics.generic_event(3);
    const simDeactivationData = Storage.get("simDeactivationData", true);
    if(simDeactivationData) {
        const parsedData = JSON.parse(simDeactivationData);
        setPhoneNumber(parsedData.phone);
    }

    const stepsDetails = {
        step1: {
            // Number
            // Prepaid & Postpaid
          status: "isDone",
        },
        step2: {
            // OTP
            // Postpaid Only
          status: "isDone",
        },
        step3: {
            // Absher
            // PrePaid Only
          status: "isDone",
        },
        step4: {
            // Payment
            // Postpaid Only
          status: "isDone",
        },
        step5: {
            // Confirmation
            // Prepaid & Postpaid
          status: "isDone",
        }
    };
    Storage.set("act_step_detail", stepsDetails);

    setLoader(false);
    return () => {
      if (subscriptions && subscriptions?.length) {
        for (let subscription of subscriptions) {
          subscription.unsubscribe();
        }
      }
    }

  }, []);

  const handleOkay = () => {    
    setLoader(true);
    localStorage.clear();
    window.location.href = Settings.site_link;
  }

  return (
    <>
      {loader ? <SpinnerTimeLoader /> :
        <>
            <div className="storefront-two-col-pg">
                <div className="stm-topup-info-container bill-payment-success-failed">
                    <div className="success-img">
                        <img src={CommonPaymentFailedIcon} alt="" />
                    </div>
                    <div className="bill-payment-pay-info-container">
                        <StorefrontTitle 
                            title={Translation.keys["stm_sim_deactivation_suspend"]}
                            desc={`${Translation.keys["stm_sim_deactivation_suspend_desc1"]} ${phoneNumber} ${Translation.keys["stm_sim_deactivation_suspend_desc2"]}`}
                        />
                        <p className="additional-pay-info">{phoneNumber}{" "}{Translation.keys["stm_sim_deactivation_suspend_desc3"]}</p>
                        <p className="additional-pay-info">{Translation.keys["stm_sim_deactivation_suspend_desc4"]}</p>
                    </div>
                    <div className="topup-field-wrapper">
                        <div className="topup-btn-section">
                        <button
                            className="storefront-button"
                            type="button"
                            onClick={() => { handleOkay() }}
                        >
                            {Translation.keys["stf_okay"]}
                        </button>
                        </div>
                    </div>
                    <DownloadApps
                        info={appDownloadInfo}
                        classes={"download-apps"}
                        google_play_link={Settings.google_play_link}
                        app_store_link={Settings.app_store_link}
                        huawei_store_link={Settings.huawei_store_link}
                    />
                </div>
                <SimDeactivationStepper />
		    </div>
        </>
      }
    </>
  );
};

export default SuspendedSimDeactivation;